import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/layout/default.vue';
Vue.use(VueRouter);
/* 권한과 상관없이 보여지는 메뉴 목록 */
export const constantRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: { hidden: true }
    }
];
export const asyncRoutes = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import('@/views/Home.vue'),
                name: 'Home',
                meta: { hidden: true }
            },
            {
                path: 'company',
                name: 'CompanyList',
                component: () => import('@/views/company/List/index.vue'),
                meta: { title: 'Company', icon: 'mdi-desktop-mac-dashboard' }
            },
            {
                path: 'company/add',
                name: 'CompanyAddForm',
                component: () => import('@/views/company/AddForm/index.vue'),
                meta: { hidden: true }
            },
            {
                path: 'company/:companyId',
                name: 'CompanyDetail',
                component: () => import('@/views/company/Detail/index.vue'),
                meta: { hidden: true }
            },
            {
                path: 'company/:companyId/members/add',
                name: 'MemberAddForm',
                component: () => import('@/views/member/AddForm/index.vue'),
                meta: { hidden: true }
            },
            {
                path: 'company/:companyId/members/:memberSeq',
                name: 'MemberDetail',
                component: () => import('@/views/member/Detail/index.vue'),
                meta: { hidden: true }
            },
            {
                path: 'company/:companyId/licenses/add',
                name: 'LicenseAddForm',
                component: () => import('@/views/license/AddForm/index.vue'),
                meta: { hidden: true }
            },
            {
                path: '/company/:companyId/license/:licenseSeq',
                name: 'LicenseDetail',
                component: () => import('@/views/license/Detail/index.vue'),
                meta: { hidden: true }
            }
        ]
    }
];
const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [...constantRoutes, ...asyncRoutes]
});
export default router;
export const useRouter = () => router;
